﻿
import GeoJSON, { Options } from 'ol/format/GeoJSON';

import Geometry from 'ol/geom/Geometry';
import { Projections } from '../models/Projections';

/**
 * Converts from and to GeoJson
 * */
class GeometryConverter {

    private static getFormatter(options?: Options) {
        return new GeoJSON({
            dataProjection: Projections.WGS,
            featureProjection: Projections.WebMercator,
            ...options
        })
    }

    public static getOpenlayersFeature(geometry: GeoJSON.GeoJSON, options?: Options) {
        if (!geometry)
            return undefined;

        try {
            return this.getFormatter(options).readFeature(geometry);
        }
        catch (e) {
            console.error(e)
            return undefined;
        }
    }

    public static getOpenlayersFeatures(geometry: GeoJSON.GeoJSON, options?: Options) {
        if (!geometry)
            return undefined;

        try {
            return this.getFormatter(options).readFeatures(geometry);
        }
        catch {
            return undefined;
        }
    }

    public static getOpenlayersGeometry(geometry: GeoJSON.GeoJSON, options?: Options) {
        if (!geometry)
            return undefined;

        try {
            return this.getFormatter(options).readGeometry(geometry);
        }
        catch (e) {
            console.error(e)
            return undefined;
        }
    }

    public static getGeojsonGeometry(geometry: Geometry, options?: Options) {

        try {
            //if (geometry instanceof Circle) 
            //    geometry = this.convertCircleGeometry(geometry, options?.featureProjection);                          

            return this.getFormatter(options).writeGeometryObject(geometry);
        }
        catch (e) {
            console.error(e)
            return undefined;
        }
    }

    //public static convertCircleGeometry(geometry: Circle, projection: ProjectionLike = Projections.WebMercator, vertices: number = 128) {
    //    const center = geometry.getCenter();
    //    const radius = geometry.getRadius();

    //    const circle = circular(
    //        transform(center, projection, Projections.WGS),
    //        radius,
    //        vertices
    //    );
    //    circle.transform(Projections.WGS, projection);

    //    return new GeodesicCircle(circle, new Point(center));
    //}
}

export default GeometryConverter;